import { Fragment } from 'react'
import { Button } from '@leroy-merlin-br/backyard-react'
import { ChevronRight } from '@backyard-ui/icons'

import { ContentTagSEO } from '../../../page'

type ContentListProps = {
  contents: ContentTagSEO[]
}

const ContentList = ({ contents }: ContentListProps) => {
  const MAX_CONTENTS = 9

  const slicedContents = contents.slice(0, MAX_CONTENTS)

  return (
    <Fragment>
      {slicedContents.map(content => (
        <Button
          as="a"
          key={content.id}
          variant="outline"
          iconRight={ChevronRight}
          href={content.url}>
          {content.title}
        </Button>
      ))}
    </Fragment>
  )
}

export default ContentList
